import { render, staticRenderFns } from "./bai2.vue?vue&type=template&id=2761f28f&scoped=true&"
import script from "./bai2.vue?vue&type=script&lang=js&"
export * from "./bai2.vue?vue&type=script&lang=js&"
import style0 from "./bai2.vue?vue&type=style&index=0&id=2761f28f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2761f28f",
  null
  
)

export default component.exports